var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-select',{attrs:{"size":"sm","select-size":1,"options":_vm.locales},model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }